
import CSSRulePlugin from 'imports-loader?define=>false!gsap/src/minified/plugins/CSSRulePlugin.min.js';

export default class Scens {
    constructor(controller) {
        this.controller = controller;
    }

    hello() {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="hello"]',
            duration: '100%',
            offset: -200,
            reverse: false,
        })
        .on('start', function () {
            var tweenScene = new TimelineLite()
            .add(TweenMax.from('.hello__header', 1, {opacity: "0", 'top': "10rem"}), 0)
            .add(TweenMax.to('.hello__header', 1, {opacity: "1", 'top': "0"}), 0)
            .add(TweenMax.from('.hello__content', 1, {opacity: "0", 'top': "15rem"}), 0.3)
            .add(TweenMax.to('.hello__content', 1, {opacity: "1", 'top': "0rem"}), 0.3)
            .add(TweenMax.from('.hello__footer', 1, {opacity: "0", 'top': "20rem"}), 0.6)
            .add(TweenMax.to('.hello__footer', 1, {opacity: "1", 'top': "1rem"}), 0.6);
        })
        .addTo(this.controller);
    }

    whatWeOffer() {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="whatWeOffer"]',
            duration: '100%',
            offset: -200,
            reverse: false,
        })
        .on('start', function () {
            var rule = CSSRulePlugin.getRule(".what-we-offer__header:before");

            var tweenScene = new TimelineLite()
            .add(TweenMax.from('.what-we-offer__header', 1, {opacity: "0", 'top': "10rem"}), 0)
            .add(TweenMax.to('.what-we-offer__header', 1, {opacity: "1", 'top': "0"}), 0)
            .add(TweenMax.from('.what-we-offer__content', 1, {opacity: "0", 'top': "15rem"}), 0.3)
            .add(TweenMax.to('.what-we-offer__content', 1, {opacity: "1", 'top': "3rem"}), 0.3)
            .add(TweenMax.from(rule, 1, {cssRule: {opacity: "0"}}), 0.6)
            .add(TweenMax.to(rule, 1, {cssRule: {opacity: "1"}}), 0.6);
            
        })
        .setClassToggle('[data-item="whatWeOffer"]', 'animation')
        .addTo(this.controller);
    }

    ForwhomHome() {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="ForwhomHome"]',
            duration: '100%',
            offset: -200,
            reverse: false,
        })
        .on('start', function () {
            let rule = CSSRulePlugin.getRule(".for-whom__header:before");
            const lion = document.querySelector('[data-item="lion"]');

            var tweenScene = new TimelineLite()
            .add(TweenMax.from('.for-whom__header', 0.8, {opacity: "0", 'top': "10rem"}), 0)
            .add(TweenMax.to('.for-whom__header', 0.8, {opacity: "1", 'top': "0"}), 0)
            .add(TweenMax.from('.for-whom__content', 0.8, {opacity: "0", 'top': "15rem"}), 0.3)
            .add(TweenMax.to('.for-whom__content', 0.8, {opacity: "1", 'top': "3rem"}), 0.3)
            .add(TweenMax.from('.for-whom__footer', 0.8, {opacity: "0", 'top': "20rem"}), 0.6)
            .add(TweenMax.to('.for-whom__footer', 0.8, {opacity: "1", 'top': "3rem"}), 0.6)
            .add(TweenMax.from('.for-whom footer', 0.8, {opacity: "0", 'top': "22rem"}), 0.8)
            .add(TweenMax.to('.for-whom footer', 0.8, {opacity: "1", 'top': "3rem"}), 0.8)
            .add(TweenMax.from(rule, 0.8, {cssRule: {opacity: "0"}}), 0.3)
            .add(TweenMax.to(rule, 0.8, {cssRule: {opacity: "1"}}), 0.3)

            lion.classList.add("animation");
        })
        .addTo(this.controller);
    }

    orange() {

        var tweenScene = new TimelineLite()
        .add(TweenMax.from('[data-item="orange"]', 1, {'background-position': "50% 190%"}), 0)
        .add(TweenMax.to('[data-item="orange"]', 1, {'background-position': "50% 100%"}), 0);

        new ScrollMagic.Scene({
            triggerElement: '[data-item="ForwhomHome"]',
            duration: '100%',
            offset: -200,
            reverse: true,
        })
        .setTween(tweenScene)
        .addTo(this.controller);
    }

    homeGallery() {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="homeGallery"]',
            duration: '100%',
            offset: -200,
            reverse: false,
        })
        .on('start', function () {

            var tweenScene = new TimelineLite()
            .add(TweenMax.from('[jedli-index="1"] .gallery-slider__col', 0.5, {'left': "20rem"}), 0)
            .add(TweenMax.to('[jedli-index="1"] .gallery-slider__col', 0.5, {'left': "0rem"}), 0)
            .add(TweenMax.from('[jedli-index="2"] .gallery-slider__col', 0.5, {'left': "20rem"}), 0.2)
            .add(TweenMax.to('[jedli-index="2"] .gallery-slider__col', 0.5, {'left': "0rem"}), 0.2)
            .add(TweenMax.from('[jedli-index="3"] .gallery-slider__col', 0.5, {'left': "20rem"}), 0.5)
            .add(TweenMax.to('[jedli-index="3"] .gallery-slider__col', 0.5, {'left': "0rem"}), 0.5);

            let prev = document.querySelectorAll("[data-item='homeGallery'] .SliderArrows__arrow--prev");
            let next = document.querySelectorAll("[data-item='homeGallery'] .SliderArrows__arrow--next");
            setTimeout(() => {
                prev.forEach(link => {
                    link.classList.remove('avoid-clicks');
                });
                next.forEach(link => {
                    link.classList.remove('avoid-clicks');
                });
            }, 2500);
        })
        .addTo(this.controller);
    }

    homeContact() {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="homeContact"]',
            duration: '100%',
            offset: -200,
            reverse: false,
        })
        .on('start', function () {

            var tweenScene = new TimelineLite()
            .add(TweenMax.from('.contact__header', 0.8, {opacity: "0", 'top': "10rem"}), 0)
            .add(TweenMax.to('.contact__header', 0.8, {opacity: "1", 'top': "0"}), 0)
            .add(TweenMax.from('.contact__content--name', 0.8, {opacity: "0", 'top': "10rem"}), 0.3)
            .add(TweenMax.to('.contact__content--name', 0.8, {opacity: "1", 'top': "0"}), 0.3)
            .add(TweenMax.from('.contact__content--phone', 0.8, {opacity: "0", 'top': "10rem"}), 0.6)
            .add(TweenMax.to('.contact__content--phone', 0.8, {opacity: "1", 'top': "0"}), 0.6)
            .add(TweenMax.from('.contact__content--address', 0.8, {opacity: "0", 'top': "10rem"}), 0.9)
            .add(TweenMax.to('.contact__content--address', 0.8, {opacity: "1", 'top': "0"}), 0.9)

            const parrot = document.querySelector('[data-item="parrot"]');
            parrot.classList.add("animation");
        })
        .addTo(this.controller);
    }
    
}